/**
 * The countries Borgo accepts, as ISO 3166-1 alpha-2 codes with Swedish names. A copy of bolane-api's
 * shared-kernel list (`src/core/sharedKernel/vocabulary/countries.ts`): a country missing here can't
 * be picked, and one missing there is rejected by the server. Nothing keeps the two in step, so add
 * or remove a country in both. `AN` and `FX` are withdrawn ISO codes, kept to match the server.
 * `XK` (Kosovo) is a user-assigned code, not an official ISO one, used by the EU and the AML system.
 *
 * `countryOptions` is a separate, older list with other users; leave it as it is.
 */
const BORGO_COUNTRY_LIST = [
  { code: 'AD', name: 'Andorra' },
  { code: 'AE', name: 'Förenade Arabemiraten' },
  { code: 'AF', name: 'Afghanistan' },
  { code: 'AG', name: 'Antigua och Barbuda' },
  { code: 'AI', name: 'Anguilla' },
  { code: 'AL', name: 'Albanien' },
  { code: 'AM', name: 'Armenien' },
  { code: 'AN', name: 'Nederländska Antillerna' },
  { code: 'AO', name: 'Angola' },
  { code: 'AQ', name: 'Antarktis' },
  { code: 'AR', name: 'Argentina' },
  { code: 'AS', name: 'Amerikanska Samoa' },
  { code: 'AT', name: 'Österrike' },
  { code: 'AU', name: 'Australien' },
  { code: 'AW', name: 'Aruba' },
  { code: 'AX', name: 'Åland' },
  { code: 'AZ', name: 'Azerbajdzjan' },
  { code: 'BA', name: 'Bosnien och Hercegovina' },
  { code: 'BB', name: 'Barbados' },
  { code: 'BD', name: 'Bangladesh' },
  { code: 'BE', name: 'Belgien' },
  { code: 'BF', name: 'Burkina Faso' },
  { code: 'BG', name: 'Bulgarien' },
  { code: 'BH', name: 'Bahrain' },
  { code: 'BI', name: 'Burundi' },
  { code: 'BJ', name: 'Benin' },
  { code: 'BL', name: 'Saint-Barthélemy' },
  { code: 'BM', name: 'Bermuda' },
  { code: 'BN', name: 'Brunei' },
  { code: 'BO', name: 'Bolivia' },
  { code: 'BQ', name: 'Karibiska Nederländerna' },
  { code: 'BR', name: 'Brasilien' },
  { code: 'BS', name: 'Bahamas' },
  { code: 'BT', name: 'Bhutan' },
  { code: 'BV', name: 'Bouvetön' },
  { code: 'BW', name: 'Botswana' },
  { code: 'BY', name: 'Vitryssland' },
  { code: 'BZ', name: 'Belize' },
  { code: 'CA', name: 'Kanada' },
  { code: 'CC', name: 'Kokosöarna' },
  { code: 'CD', name: 'Demokratiska republiken Kongo' },
  { code: 'CF', name: 'Centralafrikanska republiken' },
  { code: 'CG', name: 'Kongo-Brazzaville' },
  { code: 'CH', name: 'Schweiz' },
  { code: 'CI', name: 'Elfenbenskusten' },
  { code: 'CK', name: 'Cooköarna' },
  { code: 'CL', name: 'Chile' },
  { code: 'CM', name: 'Kamerun' },
  { code: 'CN', name: 'Kina' },
  { code: 'CO', name: 'Colombia' },
  { code: 'CR', name: 'Costa Rica' },
  { code: 'CU', name: 'Kuba' },
  { code: 'CV', name: 'Kap Verde' },
  { code: 'CW', name: 'Curaçao' },
  { code: 'CX', name: 'Julön' },
  { code: 'CY', name: 'Cypern' },
  { code: 'CZ', name: 'Tjeckien' },
  { code: 'DE', name: 'Tyskland' },
  { code: 'DJ', name: 'Djibouti' },
  { code: 'DK', name: 'Danmark' },
  { code: 'DM', name: 'Dominica' },
  { code: 'DO', name: 'Dominikanska republiken' },
  { code: 'DZ', name: 'Algeriet' },
  { code: 'EC', name: 'Ecuador' },
  { code: 'EE', name: 'Estland' },
  { code: 'EG', name: 'Egypten' },
  { code: 'EH', name: 'Västsahara' },
  { code: 'ER', name: 'Eritrea' },
  { code: 'ES', name: 'Spanien' },
  { code: 'ET', name: 'Etiopien' },
  { code: 'FI', name: 'Finland' },
  { code: 'FJ', name: 'Fiji' },
  { code: 'FK', name: 'Falklandsöarna' },
  { code: 'FM', name: 'Mikronesiska federationen' },
  { code: 'FO', name: 'Färöarna' },
  { code: 'FR', name: 'Frankrike' },
  { code: 'FX', name: 'France métropolitaine (Frankrike; europeiska delen)' },
  { code: 'GA', name: 'Gabon' },
  { code: 'GB', name: 'Storbritannien' },
  { code: 'GD', name: 'Grenada' },
  { code: 'GE', name: 'Georgien' },
  { code: 'GF', name: 'Franska Guyana' },
  { code: 'GG', name: 'Guernsey' },
  { code: 'GH', name: 'Ghana' },
  { code: 'GI', name: 'Gibraltar' },
  { code: 'GL', name: 'Grönland' },
  { code: 'GM', name: 'Gambia' },
  { code: 'GN', name: 'Guinea' },
  { code: 'GP', name: 'Guadeloupe' },
  { code: 'GQ', name: 'Ekvatorialguinea' },
  { code: 'GR', name: 'Grekland' },
  { code: 'GS', name: 'Sydgeorgien och Sydsandwichöarna' },
  { code: 'GT', name: 'Guatemala' },
  { code: 'GU', name: 'Guam' },
  { code: 'GW', name: 'Guinea Bissau' },
  { code: 'GY', name: 'Guyana' },
  { code: 'HK', name: 'Hongkong' },
  { code: 'HM', name: 'Heard- och McDonaldöarna' },
  { code: 'HN', name: 'Honduras' },
  { code: 'HR', name: 'Kroatien' },
  { code: 'HT', name: 'Haiti' },
  { code: 'HU', name: 'Ungern' },
  { code: 'ID', name: 'Indonesien' },
  { code: 'IE', name: 'Irland' },
  { code: 'IL', name: 'Israel' },
  { code: 'IM', name: 'Isle of Man' },
  { code: 'IN', name: 'Indien' },
  { code: 'IO', name: 'Brittiska territoriet i Indiska Oceanen' },
  { code: 'IQ', name: 'Irak' },
  { code: 'IR', name: 'Iran' },
  { code: 'IS', name: 'Island' },
  { code: 'IT', name: 'Italien' },
  { code: 'JE', name: 'Jersey' },
  { code: 'JM', name: 'Jamaica' },
  { code: 'JO', name: 'Jordanien' },
  { code: 'JP', name: 'Japan' },
  { code: 'KE', name: 'Kenya' },
  { code: 'KG', name: 'Kirgizistan' },
  { code: 'KH', name: 'Kambodja' },
  { code: 'KI', name: 'Kiribati' },
  { code: 'KM', name: 'Komorerna' },
  { code: 'KN', name: 'Saint Kitts och Nevis' },
  { code: 'KP', name: 'Nordkorea' },
  { code: 'KR', name: 'Sydkorea' },
  { code: 'KW', name: 'Kuwait' },
  { code: 'KY', name: 'Caymanöarna' },
  { code: 'KZ', name: 'Kazakstan' },
  { code: 'LA', name: 'Laos' },
  { code: 'LB', name: 'Libanon' },
  { code: 'LC', name: 'Saint Lucia' },
  { code: 'LI', name: 'Liechtenstein' },
  { code: 'LK', name: 'Sri Lanka' },
  { code: 'LR', name: 'Liberia' },
  { code: 'LS', name: 'Lesotho' },
  { code: 'LT', name: 'Litauen' },
  { code: 'LU', name: 'Luxemburg' },
  { code: 'LV', name: 'Lettland' },
  { code: 'LY', name: 'Libyen' },
  { code: 'MA', name: 'Marocko' },
  { code: 'MC', name: 'Monaco' },
  { code: 'MD', name: 'Moldavien' },
  { code: 'ME', name: 'Montenegro' },
  { code: 'MF', name: 'Saint-Martin' },
  { code: 'MG', name: 'Madagaskar' },
  { code: 'MH', name: 'Marshallöarna' },
  { code: 'MK', name: 'Makedonien' },
  { code: 'ML', name: 'Mali' },
  { code: 'MM', name: 'Burma' },
  { code: 'MN', name: 'Mongoliet' },
  { code: 'MO', name: 'Macau' },
  { code: 'MP', name: 'Nordmarianerna' },
  { code: 'MQ', name: 'Martinique' },
  { code: 'MR', name: 'Mauretanien' },
  { code: 'MS', name: 'Montserrat' },
  { code: 'MT', name: 'Malta' },
  { code: 'MU', name: 'Mauritius' },
  { code: 'MV', name: 'Maldiverna' },
  { code: 'MW', name: 'Malawi' },
  { code: 'MX', name: 'Mexiko' },
  { code: 'MY', name: 'Malaysia' },
  { code: 'MZ', name: 'Moçambique' },
  { code: 'NA', name: 'Namibia' },
  { code: 'NC', name: 'Nya Kaledonien' },
  { code: 'NE', name: 'Niger' },
  { code: 'NF', name: 'Norfolkön' },
  { code: 'NG', name: 'Nigeria' },
  { code: 'NI', name: 'Nicaragua' },
  { code: 'NL', name: 'Nederländerna' },
  { code: 'NO', name: 'Norge' },
  { code: 'NP', name: 'Nepal' },
  { code: 'NR', name: 'Nauru' },
  { code: 'NU', name: 'Niue' },
  { code: 'NZ', name: 'Nya Zeeland' },
  { code: 'OM', name: 'Oman' },
  { code: 'PA', name: 'Panama' },
  { code: 'PE', name: 'Peru' },
  { code: 'PF', name: 'Franska Polynesien' },
  { code: 'PG', name: 'Papua Nya Guinea' },
  { code: 'PH', name: 'Filippinerna' },
  { code: 'PK', name: 'Pakistan' },
  { code: 'PL', name: 'Polen' },
  { code: 'PM', name: 'Saint-Pierre och Miquelon' },
  { code: 'PN', name: 'Pitcairnöarna' },
  { code: 'PR', name: 'Puerto Rico' },
  { code: 'PS', name: 'Palestina' },
  { code: 'PT', name: 'Portugal' },
  { code: 'PW', name: 'Palau' },
  { code: 'PY', name: 'Paraguay' },
  { code: 'QA', name: 'Qatar' },
  { code: 'RE', name: 'Réunion' },
  { code: 'RO', name: 'Rumänien' },
  { code: 'RS', name: 'Serbien' },
  { code: 'RU', name: 'Ryssland' },
  { code: 'RW', name: 'Rwanda' },
  { code: 'SA', name: 'Saudiarabien' },
  { code: 'SB', name: 'Salomonöarna' },
  { code: 'SC', name: 'Seychellerna' },
  { code: 'SD', name: 'Sudan' },
  { code: 'SE', name: 'Sverige' },
  { code: 'SG', name: 'Singapore' },
  { code: 'SH', name: 'Sankta Helena' },
  { code: 'SI', name: 'Slovenien' },
  { code: 'SJ', name: 'Svalbard och Jan Mayen' },
  { code: 'SK', name: 'Slovakien' },
  { code: 'SL', name: 'Sierra Leone' },
  { code: 'SM', name: 'San Marino' },
  { code: 'SN', name: 'Senegal' },
  { code: 'SO', name: 'Somalia' },
  { code: 'SR', name: 'Surinam' },
  { code: 'SS', name: 'Sydsudan' },
  { code: 'ST', name: 'São Tomé och Príncipe' },
  { code: 'SV', name: 'El Salvador' },
  { code: 'SX', name: 'Sint Maarten' },
  { code: 'SY', name: 'Syrien' },
  { code: 'SZ', name: 'Swaziland' },
  { code: 'TC', name: 'Turks- och Caicosöarna' },
  { code: 'TD', name: 'Tchad' },
  { code: 'TF', name: 'Franska södra territorierna' },
  { code: 'TG', name: 'Togo' },
  { code: 'TH', name: 'Thailand' },
  { code: 'TJ', name: 'Tadzjikistan' },
  { code: 'TK', name: 'Tokelauöarna' },
  { code: 'TL', name: 'Östtimor a.k.a. Timor-Leste' },
  { code: 'TM', name: 'Turkmenistan' },
  { code: 'TN', name: 'Tunisien' },
  { code: 'TO', name: 'Tonga' },
  { code: 'TR', name: 'Turkiet' },
  { code: 'TT', name: 'Trinidad och Tobago' },
  { code: 'TV', name: 'Tuvalu' },
  { code: 'TW', name: 'Taiwan' },
  { code: 'TZ', name: 'Tanzania' },
  { code: 'UA', name: 'Ukraina' },
  { code: 'UG', name: 'Uganda' },
  { code: 'UM', name: 'USA:s yttre öar' },
  { code: 'US', name: 'USA' },
  { code: 'UY', name: 'Uruguay' },
  { code: 'UZ', name: 'Uzbekistan' },
  { code: 'VA', name: 'Vatikanstaten' },
  { code: 'VC', name: 'Saint Vincent och Grenadinerna' },
  { code: 'VE', name: 'Venezuela' },
  { code: 'VG', name: 'Brittiska Jungfruöarna' },
  { code: 'VI', name: 'Amerikanska Jungfruöarna' },
  { code: 'VN', name: 'Vietnam' },
  { code: 'VU', name: 'Vanuatu' },
  { code: 'WF', name: 'Wallis- och Futunaöarna' },
  { code: 'WS', name: 'Samoa' },
  { code: 'XK', name: 'Kosovo' },
  { code: 'YE', name: 'Jemen' },
  { code: 'YT', name: 'Mayotte' },
  { code: 'ZA', name: 'Sydafrika' },
  { code: 'ZM', name: 'Zambia' },
  { code: 'ZW', name: 'Zimbabwe' },
] as const

export type BorgoCountryCode = (typeof BORGO_COUNTRY_LIST)[number]['code']

export interface BorgoCountry {
  code: BorgoCountryCode
  name: string
}

/** Sorted by Swedish name. */
export const BORGO_COUNTRIES: readonly BorgoCountry[] = [...BORGO_COUNTRY_LIST].sort((a, b) =>
  a.name.localeCompare(b.name, 'sv'),
)

const namesByCode: ReadonlyMap<string, string> = new Map(BORGO_COUNTRIES.map((country) => [country.code, country.name]))

export const isBorgoCountry = (code: string): code is BorgoCountryCode => namesByCode.has(code)

/** The Swedish name, or the code itself for a code outside the list. */
export const borgoCountryName = (code: string): string => namesByCode.get(code) ?? code
